import Link from "next/link"
import styles from "./TopicList.module.css"
import { Topic } from "../../../interfaces/props.interface"

const TopicList = ({
  topics,
  selected,
}: {
  topics: Topic[]
  selected?: string
}) => {
  return (
    <div className={styles.topicList}>
      {topics?.map(({ title, slug }: any, idx: number) => (
        <Link href={`/categoria/${slug}`} key={idx} passHref>
          {selected === slug ? (
            <a className={styles.selectedTopicCard}>{title}</a>
          ) : (
            <a className={styles.topicCard}>{title}</a>
          )}
        </Link>
      ))}
    </div>
  )
}

export default TopicList
